// src/App.tsx
import React from 'react';
import logo from './logo.svg';
import './App.css';
import Main from './components/content/Main';
import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';
import './css/bootstrap.min.css';
import './css/style.css';
import './css/style.scss';
import './css/getstarted.css';
import './css/getstarted.scss';
import './css/master.css';
import './css/master.scss';
import './css/now-icon.css';
import './css/nowtvicons.css';
import './App.css';
import './css/combo-pack.css';
import './css/custom-style.css';
import './css/pack-overview.css';
import GetStarted from './components/content/GetStarted';
import BoxPlanDetail from './components/content/GetStarted/BoxPlanDetail';
import MinisitePage from './components/content/Minisite';
import ChannelOverViewPage from './components/content/ChannelOverview';
import { fetchMinisite } from './components/functions/fetchMinisite';
import AvailableChannelPacks from './components/content/AvailableChannelPacks';
import Recommendation from './components/content/Recommendation';
import BlogPage from './components/content/Blog';
import Article from './components/content/Blog/Article';
import BlogFilter from './components/content/Blog/BlogFilter';
import Support from './components/content/Support/Support';
import SupportItem from './components/content/Support/SupportItem';
import SupportFrequentlyReadArticles from './components/content/Support/SupportFrequentlyReadArticles';
import SupportSearchResult from './components/content/Support/SupportSearchResult';
import HktAiAssistant from './components/content/HktAiAssistant';

import { ENV } from './config';
//remove all console logs
if (ENV === 'production' || ENV === 'preproduction') {
   console.log = function() {}
}
function App() {
  return (
    <Router>
      <Routes>
        <Route
          path="/"
          element={
            <div className="App">
              <header className="App-header">
                <img src={logo} className="App-logo" alt="logo" />
                <Main />
              </header>
            </div>
          }
        />
        <Route path="/get-started" element={<GetStarted />} />
        <Route path="/get-started-box" element={<GetStarted />} />
        <Route path="/combo-pack/:id" element={<BoxPlanDetail />} />
        <Route path="/hktaiassistant" element={<HktAiAssistant />} />
        <Route path="/:slug" element={<MinisitePage />} />
        <Route path="/channel-overview" element={<ChannelOverViewPage />} />
        <Route path="/available-channel-packs" element={<AvailableChannelPacks/>} />
        <Route path='/subscribe_recommendation' element={<Recommendation />} />
        <Route path='/upgrade_recommendation' element={<Recommendation />} />
        <Route path="/blog" element={<BlogPage />} />
        <Route path="/blog/:slug" element={<Article />} />
        <Route path="/blog/filter" element={<BlogFilter />} />
        <Route path="/blog/filter/:cid" element={<BlogFilter />} />
        <Route path='/support' element={<Support/>} />
        <Route path='/support/:slug' element={<SupportItem/>} />
        <Route path='/frequently-read-articles' element={<SupportFrequentlyReadArticles/>} />
        <Route path='/support-search-result' element={<SupportSearchResult />} />
      </Routes>
    </Router>
  );
}

export default App;